import { useLocation, useNavigate } from "react-router-dom";
import AuthLayout from "../../blocs/AuthLayout";
import "../../assets/_reset.scss";
import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const StepTwoReset = () => {
  const location = useLocation();
  let email = location?.state?.email;
  // console.log({email})
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  function handleInput(e, index) {
    const input = e.target;
    const previousInput = inputRefs[index - 1];
    const nextInput = inputRefs[index + 1];

    // Update code state with single digit
    const newCode = [...code];
    // Convert lowercase letters to uppercase
    if (/^[a-z]+$/.test(input.value)) {
      const uc = input.value.toUpperCase();
      newCode[index] = uc;
      inputRefs[index].current.value = uc;
    } else {
      newCode[index] = input.value;
    }
    setCode(newCode.join(""));

    input.select();

    if (input.value === "") {
      // If the value is deleted, select previous input, if exists
      if (previousInput) {
        previousInput.current.focus();
      }
    } else if (nextInput) {
      // Select next input on entry, if exists
      nextInput.current.select();
    }
    // console.log("code", code);
  }
  // Select the contents on focus
  function handleFocus(e) {
    e.target.select();
  }
  const ResendCode=async()=>{
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}forgot-password`,
        {
          email,
        }
      );
      // a changer
      toast.success(response?.data?.message)
     // navigate("/sendCode", {state:{email}}); // Redirect to the profile page
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "Échec de la connexion";
        toast.error(errorMessage)
      
    }
  }
  const validateCode=async()=>{
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}verify-reset-code`,
        {
          email,
          code
          
        }
      );
      navigate("/nv-mot-de-passe", {state:{email,code}}); // Redirect to the profile page
    } catch (err) {
      const errorMessage =
              err.response?.data?.error || "Échec de la connexion";
              toast.error(errorMessage);
      
    }
  }
  // Handle backspace key
  function handleKeyDown(e, index) {
    const input = e.target;
    const previousInput = inputRefs[index - 1];
    const nextInput = inputRefs[index + 1];

    if ((e.keyCode === 8 || e.keyCode === 46) && input.value === "") {
      e.preventDefault();
      setCode(
        (prevCode) => prevCode.slice(0, index) + prevCode.slice(index + 1)
      );
      if (previousInput) {
        previousInput.current.focus();
      }
    }
  }
  // Capture pasted characters
  const handlePaste = (e) => {
    const pastedCode = e.clipboardData.getData("text");
    if (pastedCode.length === 4) {
      setCode(pastedCode);
      inputRefs.forEach((inputRef, index) => {
        inputRef.current.value = pastedCode.charAt(index);
      });
    }
  };

  return (
    <>
      <AuthLayout
        image="../images/prestaLeftImg.png"
        title="Réservez tous vos <strong>services pros </strong>, quand et où vous voulez."
      >
        <div className=" col-md-8 mx-auto">
          <h3 className="grey500">Mot de passe oublié</h3>
          <p className="body grey66 mt-16">
            Un code de vérification vous a été envoyé sur {email}. Si
            vous ne le voyez pas, pensez à regarder dans vos courriers
            indésirables.{" "}
          </p>
          <p className="legend grey66 mt-24">Code de vérification*</p>
          <div className="row d-flex justify-content-start gap-2 relative px-16  mx-auto">

            {[0, 1, 2, 3].map((index) => (
              <input
                className=" code-input text-2xl bg-gray-800 w-10 flex p-2 text-center"
                key={index}
                type="text"
                maxLength={1}
                onChange={(e) => handleInput(e, index)}
                ref={inputRefs[index]}
                autoFocus={index === 0}
                onFocus={handleFocus}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onPaste={handlePaste}
              />
            ))}
          </div>
          <p className="body grey66 mt-24 mb-0">Vous n’avez pas reçu de code ?</p>
          <button onClick={ResendCode} className="link-blue">
            Renvoyer un code
          </button>

          <button type="submit" onClick={validateCode} disabled={code.length<4} className="twyny-cta-primary w-100 mt-24" >
            Valider
          </button>
        </div>
      </AuthLayout>
    </>
  );
};
export default StepTwoReset;
